import { render, staticRenderFns } from "./FieldHtml.vue?vue&type=template&id=16f1a87f&scoped=true&"
import script from "./FieldHtml.vue?vue&type=script&lang=js&"
export * from "./FieldHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1a87f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f1a87f')) {
      api.createRecord('16f1a87f', component.options)
    } else {
      api.reload('16f1a87f', component.options)
    }
    module.hot.accept("./FieldHtml.vue?vue&type=template&id=16f1a87f&scoped=true&", function () {
      api.rerender('16f1a87f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldHtml.vue"
export default component.exports